<template>
  <div class="account">
    <h3>Account</h3>
  </div>
</template>

<script>
  export default {
    name: 'account',
    data () {
      return {
      }
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
  }
</script>

<style lang="scss" scoped>
  @import '../style/_shared.scss';

  .account {
    @extend .pnl;
    @extend .hw100;
    @extend .pad1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Account.vue